<div class="error-dialog-wrapper">
  <mat-icon>error</mat-icon>
  <div mat-dialog-content >
    <h4>{{data.title || 'Någonting gick fel'}}</h4>
    @for (msg of data.message; track msg) {
      <p>{{msg}}</p>
    }
  </div>
  <div mat-dialog-actions class="buttons">
    <button mat-button (click)="close()">Stäng</button>
  </div>
</div>